document.addEventListener('DOMContentLoaded', function() {
  const increaseButtons = document.querySelectorAll('.cart-item--quantity-increase');
  const decreaseButtons = document.querySelectorAll('.cart-item--quantity-decrease');

  // Event listener for decrease button
  decreaseButtons.forEach(button => {
    const input = button.nextElementSibling;
    button.addEventListener('click', function() {
      const newQuantity = Math.max(1, parseInt(input.value) - 1); // Ensure quantity doesn't go below 1
      updateCartQuantity(input, newQuantity);
    });
  });

  // Event listener for increase button
  increaseButtons.forEach(button => {
    const input = button.previousElementSibling;
    button.addEventListener('click', function() {
      const newQuantity = parseInt(input.value) + 1;
      updateCartQuantity(input, newQuantity);
    });
  });

  function updateCartQuantity(input, quantity) {
    input.value = quantity;
    document.getElementById('cart_form').submit();
  }
});
